import BaseAPI from '../api'
const path = 'roles'
const app_path = 'app-roles'
export interface RoleInterface {
    idRole?: number
    roleName?: string
    roleStatus?: string
    permission?: any
    page?: number;
    limit?: number;
    keyword?: string;
    sortBy?: string;
    sortType?: string;
}

export default class RoleApi extends BaseAPI {

    static getAllRoles(props: RoleInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
            .then((res) => res)
    }
    static getNewRole(props: RoleInterface): Promise<any> {
        return this.api.get(`${path}/${props.idRole}`, {})
            .then((res) => res)
    }
    static getRoles(props: RoleInterface): Promise<any> {
        return this.api.get(`${app_path}`, { params: { ...props } })
            .then((res) => res)
    }
    static postRole(props: RoleInterface): Promise<any> {
        return this.api.post(`${app_path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchRole(idRole: string, props: RoleInterface): Promise<any> {
        return this.api.patch(`${app_path}/${idRole}`, { ...props }, {})
            .then((res) => res)
    }
    static getRole(props: RoleInterface): Promise<any> {
        return this.api.get(`${app_path}/${props.idRole}`, {})
            .then((res) => res)
    }
}